export default class Quiz {
    constructor(api, eventBus) {
        this.api = api;
        this.eventBus = eventBus;
    }

    fetchData(turn_id) {
        return this.api.getQuizData(turn_id)
            .then(data => data)
    }

    submitAnswer(answer_id, question_time, turn_id) {
        return this.api.submitAnswer(answer_id, question_time, turn_id)
            .then(data => data)
    }
}